export const bytesToMegaBytes = (bytes: number) => bytes / (1024 * 1024);
